import { render, staticRenderFns } from "./Day23.vue?vue&type=template&id=6ed7bb2c&"
import script from "./Day23.vue?vue&type=script&lang=js&"
export * from "./Day23.vue?vue&type=script&lang=js&"
import style0 from "./Day23.vue?vue&type=style&index=0&id=6ed7bb2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports